module.exports = __webpack_public_path__ + "img/a-2-net.9563bfb9.png";